"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _store = require("@/api/store");
var _api = require("./api");
var _validate = require("@/utils/validate.js");
var _fliterConfig = _interopRequireDefault(require("./fliterConfig.js"));
var _paginationEffect = _interopRequireDefault(require("@/utils/paginationEffect"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var _default = exports.default = {
  data: function data() {
    return _objectSpread(_objectSpread(_objectSpread({
      JavaInfo: false,
      userType: null,
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        type: '0'
      },
      initForm: {}
    }, (0, _fliterConfig.default)({
      handleSearch: this.handleSearch
    })), (0, _paginationEffect.default)(this.getList)), {}, {
      auditSpuOrSkuRef: '',
      priceAdjustmentItemRef: ''
    });
  },
  methods: {
    //审核
    auditItem: function auditItem(id, status, text) {
      this.$refs.auditSpuOrSkuRef.setOpen(id, status, text);
    },
    //调价记录
    priceAdjustmentItem: function priceAdjustmentItem(id) {
      this.$refs.priceAdjustmentItemRef.setOpen(id, 'store');
    },
    //上架状态
    changeIsShow: function changeIsShow(row) {
      this.$refs.ChanageIsShowVueRef.open(row);
    },
    handleSearch: function handleSearch(data) {
      if (data) {
        this.tableFrom = _objectSpread(_objectSpread({}, this.tableFrom), data);
      } else {
        this.tableFrom = {
          type: '0'
        };
      }
      this.resetPageData();
    },
    // 导出
    exports: function exports() {
      (0, _store.productExcelApi)(_objectSpread({}, this.tableFrom)).then(function (res) {
        window.location.href = res.fileName;
      });
    },
    // 列表
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      var params = _objectSpread(_objectSpread({}, this.tableFrom), this.pageData);
      (0, _store.productLstApi)(params).then(function (res) {
        _this.tableData.data = res.list;
        _this.tableData.total = res.total;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
        _this.$message.error(err);
      });
    },
    // 删除
    handleDelete: function handleDelete(id, type) {
      var _this2 = this;
      this.$modalSure(this.tableFrom.type === '5' ? "\u5220\u9664 id \u4E3A ".concat(id, " \u7684\u5546\u54C1\u5417\uFF1F") : "\u5C06 id \u4E3A ".concat(id, " \u7684\u5546\u54C1\u52A0\u5165\u56DE\u6536\u7AD9\u5417\uFF1F")).then(function () {
        var deleteFlag = type == 5 ? 'delete' : 'recycle';
        (0, _store.productDeleteApi)(id, deleteFlag).then(function () {
          _this2.$message.success('删除成功');
          if (_this2.tableData.data.length === 1 && _this2.tableFrom.page > 1) _this2.tableFrom.page = _this2.tableFrom.page - 1;
          _this2.getList();
        });
      });
    },
    onchangeIsShow: function onchangeIsShow(row) {
      var _this3 = this;
      row.isShow ? (0, _store.putOnShellApi)(row.id).then(function () {
        _this3.$message.success('上架成功');
        _this3.getList();
      }).catch(function () {
        row.isShow = !row.isShow;
      }) : (0, _store.offShellApi)(row.id).then(function () {
        _this3.$message.success('下架成功');
        _this3.getList();
      }).catch(function () {
        row.isShow = !row.isShow;
      });
    },
    inputSort: (0, _validate.Debounce)(/*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(row) {
        var params, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              params = _objectSpread({}, row);
              _context.p = 1;
              _context.n = 2;
              return (0, _api.updateSortApi)(params);
            case 2:
              this.$message.success('排序成功');
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              this.$message.error(_t.msg);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()),
    previewImg: function previewImg(img) {
      //预览图片
      this.$previewImg({
        imageList: [img]
      });
    },
    editGoods: function editGoods(id) {
      sessionStorage.setItem('SPU_SEARCH_FORM', JSON.stringify(this.tableFrom));
      this.$router.push('/store/list/creatProduct/' + id);
    }
  }
};